import { useState, useEffect } from "react"

const useDebounce = (value: string, milliseconds: number) => { 
  const [debouncedValue, setDebouncedValue] = useState<string>(value)

  useEffect(()=>{
    const debounceTimeout = setTimeout(()=>{
      setDebouncedValue(value)
    }, milliseconds)

    return () => {
      clearTimeout(debounceTimeout)
    }

  },[value, milliseconds])

  return debouncedValue
}

export default useDebounce